// extracted by mini-css-extract-plugin
export default {"pill":"bhlUCKZJzwuvjvEusLMq","info":"wZJ7ARO2KvEsv4rvnDD1","danger":"kgdmftJnmadLEu3_UNLv"};